import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-user-interest-manu',
  standalone: false,
  templateUrl: './user-interest-manu.component.html',
  styleUrl: './user-interest-manu.component.css'
})
export class UserInterestManuComponent {
 
  menuItems = [
    { path: "UserInterest", label: "MENU.USER_INTEREST", icon: "❤️" },
    { path: "EditUserInterest", label: "MENU.EDIT_INTEREST", icon: "✏️" }
  ];
  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "UserInterest": "bi bi-heart text-primary",  
      "EditUserInterest": "bi bi-pencil-square text-primary", 
      
    };
    return iconMap[path] || "bi bi-circle"; 
  }
userRole:string
constructor(private auth:AuthService){
    this.userRole=this.auth.getRoles();
}


}
